"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3348],{

/***/ 28214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ MapGeoFence; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/utils/validators/GeoFence.ts
var GeoFence = __webpack_require__(23218);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 4 modules
var Container = __webpack_require__(90886);
;// CONCATENATED MODULE: ./src/components/MapGeoFence/styles/MapGeoFence.styles.ts


var MapContainer = (0,styled/* default */.Z)(Container/* default */.Z)({
    margin: "0",
    padding: 0,
    maxHeight: 600,
    height: "calc(100vh)",
    zIndex: 99
});

;// CONCATENATED MODULE: ./src/components/MapGeoFence/MapGeoFence.tsx





var CENTER_COORDS = {
    lat: -33.44,
    lng: -70.623911
};
var MEKI_COORDS = {
    lat: -33.3925354,
    lng: -70.623911
};
function loadScript(src, position, id) {
    if (!position) {
        return;
    }
    var script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.setAttribute("id", id);
    script.src = src;
    position.appendChild(script);
}
function MapGeoFence(props) {
    var _zoom = props.zoom, zoom = _zoom === void 0 ? 10 : _zoom;
    var loaded = (0,react.useRef)(false);
    var mapId = (0,react.useRef)(Math.random());
    var defaultCenter = CENTER_COORDS;
    var mapRef = (0,react.useRef)(null);
    var initMap = (0,react.useCallback)(function initMapFunc() {
        var element = document.getElementById(mapId.current.toString());
        if (!element) {
            setTimeout(function() {
                initMapFunc();
            }, 500);
            return;
        }
        var allowedBounds = new google.maps.LatLngBounds(new google.maps.LatLng(GeoFence/* outsidePaintZone.0.lat */.tx[0].lat, GeoFence/* outsidePaintZone.0.lng */.tx[0].lng), new google.maps.LatLng(GeoFence/* outsidePaintZone.2.lat */.tx[2].lat, GeoFence/* outsidePaintZone.2.lng */.tx[2].lng));
        mapRef.current = new google.maps.Map(element, {
            center: new google.maps.LatLng(defaultCenter.lat, defaultCenter.lng),
            zoom: zoom,
            minZoom: 10,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            restriction: {
                latLngBounds: allowedBounds,
                strictBounds: true
            }
        });
        new google.maps.Marker({
            map: mapRef.current,
            position: MEKI_COORDS,
            icon: {
                url: "/assets/images/pinfarmacia.png",
                scaledSize: new google.maps.Size(75.4 / 2, 98.4 / 2)
            }
        });
        var combinedPaths = [
            GeoFence/* outsidePaintZone */.tx,
            GeoFence/* geoFence */.EM
        ];
        new google.maps.Polygon({
            paths: combinedPaths,
            fillColor: "#cc0000",
            fillOpacity: 0.1,
            map: mapRef.current,
            strokeColor: "#cc0000",
            strokeWeight: 1
        });
    }, [
        defaultCenter,
        zoom
    ]);
    (0,react.useEffect)(function() {
        if ( true && !loaded.current) {
            if (!document.querySelector("#google-maps-script")) {
                window.initMap = function localInitMap() {
                    initMap();
                    window.initMap = undefined;
                };
                loadScript("https://maps.googleapis.com/maps/api/js?key=".concat(environment/* GOOGLE_API_KEY */.JO, "&libraries=places&callback=initMap&language=es-419&region=cl"), document.querySelector("head"), "google-maps-script");
            } else {
                if (!window.initMap) {
                    initMap();
                }
            }
            loaded.current = true;
        }
    }, [
        initMap
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MapContainer, {
        id: mapId.current.toString(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
}


/***/ }),

/***/ 90511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ ModalDispatchZones; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIosRounded.js
var ArrowBackIosRounded = __webpack_require__(42065);
// EXTERNAL MODULE: ./src/components/MapGeoFence/MapGeoFence.tsx + 1 modules
var MapGeoFence = __webpack_require__(28214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(73224);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
;// CONCATENATED MODULE: ./src/screens/home/components/modalDispatchZones.styles.tsx



var ModalHeader = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: "36px",
        fontFamily: "Poppins",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        padding: "8px 0px"
    }, theme.breakpoints.down("md"), {
        fontSize: "16px",
        lineHeight: "24px"
    });
});
var BackButton = (0,styled/* default */.Z)(IconButton/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "absolute",
        left: "10px",
        fontSize: "16px",
        fontWeight: 600,
        padding: 0
    }, theme.breakpoints.down("md"), {
        fontSize: "12px",
        lineHeight: "18px"
    });
});
var MapContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        flexGrow: 1,
        width: "100%",
        overflow: "hidden"
    };
});
var ModalContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "absolute",
        backgroundColor: "white",
        width: "60%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "32px",
        overflow: "hidden",
        paddingTop: "8px"
    }, theme.breakpoints.down("md"), {
        width: "100%",
        height: "100dvh",
        borderRadius: "0px"
    });
});


;// CONCATENATED MODULE: ./src/screens/home/components/modalDispatchZones.tsx





var ModalDispatchZones = function(param) {
    var isModalOpen = param.isModalOpen, handleCloseModal = param.handleCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isModalOpen,
        onClose: handleCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                            onClick: handleCloseModal,
                            color: "inherit",
                            "aria-label": "back",
                            size: "large",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIosRounded/* default */.Z, {})
                        }),
                        "Zonas de despacho"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MapContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MapGeoFence/* MapGeoFence */.E, {
                        zoom: 10
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 63348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/home/footer.styles.tsx



var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#004C8C"
});
var FooterContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    padding: "8px 16px",
    "@media (min-width: 768px)": {
        flexDirection: "row",
        justifyContent: "space-between",
        padding: "30px 60px"
    },
    "@media (min-width: 992px)": {
        padding: "60px 40px"
    }
});
var DivGroupLeftContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 1100px)": {
        flexDirection: "row",
        margin: "0px 40px"
    }
});
var DivGroupRightContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 1100px)": {
        flexDirection: "row",
        margin: "0px 40px"
    }
});
var DivContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    marginRight: "40px",
    gap: "8px",
    minHeight: "258px",
    width: "100%",
    justifyContent: "space-between",
    height: "100%"
});
var ContentDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%"
});
var RightsReservedContainer = (0,styled/* default */.Z)("div")({
    textAlign: "center",
    color: "#FFFFFF",
    padding: "17px 0px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontSize: "20px",
    lineHeight: "30px",
    letterSpacing: "0.15px",
    fontWeight: 600,
    color: "#FFFFFF",
    padding: "12px 0px",
    marginTop: "30px"
});
var TextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontSize: "17px",
        lineHeight: "25.5px",
        letterSpacing: "0.15px",
        fontWeight: 400,
        color: "#FFFFFF",
        cursor: "pointer",
        paddingBottom: "10px"
    }, theme.breakpoints.down("md"), {
        paddingBottom: "10px",
        fontSize: "14px"
    });
});
var ImageContainer = (0,styled/* default */.Z)("div")(function() {
    return {
        position: "relative",
        zIndex: 1,
        marginRight: "100px"
    };
});
var IconContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    position: "relative",
    width: "24px",
    height: "24px",
    marginRight: "8px",
    cursor: "pointer"
});
var RRSSIconContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    position: "relative",
    width: "32px",
    height: "32px",
    marginRight: "15px",
    cursor: "pointer",
    marginTop: "-3px"
});
var RRSSContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    height: "100%"
});
var IconGroupContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row"
});
var IconTextContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row"
});


// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/home/components/modalDispatchZones.tsx + 1 modules
var modalDispatchZones = __webpack_require__(90511);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ./src/screens/home/footer.tsx













function Footer() {
    var track = (0,useSegment/* useSegment */.K)().track;
    var pathname = (0,router.useRouter)().pathname;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isDesktop = width > 1024;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var handleOpenModal = function() {
        return setIsModalOpen(true);
    };
    var handleCloseModal = function() {
        return setIsModalOpen(false);
    };
    var INFOOPTIONS = (0,react.useMemo)(function() {
        return [
            {
                title: "Zonas de despachos",
                openFile: function() {
                    return handleOpenModal();
                }
            },
            {
                title: "Info. Paciente",
                route: (0,utils/* getRoute */.Bv)("regulatoryInfoGeneral")
            },
            {
                title: "Info. Toxicol\xf3gica",
                route: (0,utils/* getRoute */.Bv)("regulatoryInfoToxicology")
            },
            {
                title: "Desabastecimiento",
                route: (0,utils/* getRoute */.Bv)("regulatoryInfoShortage")
            },
            {
                title: "Regulaci\xf3n",
                route: (0,utils/* getRoute */.Bv)("regulatoryInfoDecrees")
            },
            {
                title: "T\xe9rminos y condiciones",
                route: (0,utils/* getRoute */.Bv)("regulatoryInfoTermsAndConditions")
            },
            {
                title: "Pol\xedtica de privacidad",
                route: (0,utils/* getRoute */.Bv)("regulatoryInfoPrivacyPolicy")
            }, 
        ];
    }, []);
    var ASSISTOPTIONS = (0,react.useMemo)(function() {
        return [
            {
                title: "Consultas Qu\xedmico",
                route: (0,utils/* getRoute */.Bv)("pharmaceutical").toLink()
            },
            {
                title: "Devoluciones",
                route: (0,utils/* getRoute */.Bv)("devolutions").toLink()
            },
            {
                title: "Sugerencias y reclamos",
                route: (0,utils/* getRoute */.Bv)("suggestions").toLink()
            }, 
        ];
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modalDispatchZones/* ModalDispatchZones */.$, {
                isModalOpen: isModalOpen,
                handleCloseModal: handleCloseModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivGroupLeftContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentDiv, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                                variant: "h2",
                                                children: "\xbfNECESITAS AYUDA?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "mailto:contacto@farmaciameki.cl",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconTextContainer, {
                                                    onClick: function() {
                                                        void track("contact", {
                                                            to: "email"
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/assets/images/home/mailIcon.webp",
                                                                alt: "email",
                                                                layout: "fill",
                                                                objectFit: "contain"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                                            children: "contacto@farmaciameki.cl"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=Hola!%20Les%20escribo%20porque%20quiero"),
                                                target: "_blank",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconTextContainer, {
                                                    onClick: function() {
                                                        void track("contact", {
                                                            to: "phone"
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/assets/images/home/whatsappIcon.webp",
                                                                alt: "Whatsapp",
                                                                layout: "fill",
                                                                objectFit: "contain"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                                            children: environment/* PHONE_NUMBER.DISPLAY */.UE.DISPLAY
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentDiv, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                                variant: "h2",
                                                children: "\xbfD\xd3NDE ESTAMOS?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconTextContainer, {
                                                onClick: function() {
                                                    window.open("https://www.google.com/maps/place/Meki+-+Farmacia+a+domicilio/@-33.3933837,-70.6239762,17.18z/data=!4m6!3m5!1s0x9662c7cd03b3360d:0x53359a5be494b0ae!8m2!3d-33.3925354!4d-70.6239333!16s%2Fg%2F11rrvtrsrm", "_blank");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "/assets/images/home/locationIcon.webp",
                                                            alt: "Location",
                                                            layout: "fill",
                                                            objectFit: "contain"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://www.google.com/maps/place/Meki+-+Farmacia+a+domicilio/@-33.3933837,-70.6239762,17.18z/data=!4m6!3m5!1s0x9662c7cd03b3360d:0x53359a5be494b0ae!8m2!3d-33.3925354!4d-70.6239333!16s%2Fg%2F11rrvtrsrm",
                                                        target: "_blank",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                                            children: "Av. El Salto 4001・Local 8, Huechuraba, RM"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentDiv, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                                variant: "h2",
                                                children: "ASISTENCIA"
                                            }),
                                            ASSISTOPTIONS.map(function(option) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, option.route), {
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                                            children: option.title
                                                        })
                                                    }))
                                                }, option.title);
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDiv, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RRSSContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                                    children: "REDES SOCIALES"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconGroupContainer, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RRSSIconContainer, {
                                                            onClick: function() {
                                                                void track("rrss", {
                                                                    to: "instagram"
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "https://www.instagram.com/farmaciameki/",
                                                                target: "_blank",
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    layout: "fill",
                                                                    src: "/assets/logos/instagramLogo.webp",
                                                                    alt: "Instagram",
                                                                    objectFit: "contain"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RRSSIconContainer, {
                                                            onClick: function() {
                                                                void track("rrss", {
                                                                    to: "facebook"
                                                                });
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "https://www.facebook.com/farmaciameki/",
                                                                target: "_blank",
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    layout: "fill",
                                                                    src: "/assets/logos/facebookLogo.webp",
                                                                    alt: "Facebook",
                                                                    objectFit: "contain"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DivContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentDiv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                            variant: "h2",
                                            children: "INFORMACI\xd3N"
                                        }),
                                        INFOOPTIONS.map(function(option) {
                                            var ref;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: option.route ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = option.route) === null || ref === void 0 ? void 0 : ref.toModalLink(pathname)), {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                                        children: option.title
                                                    })
                                                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                                                    onClick: option.openFile,
                                                    children: option.title
                                                })
                                            }, option.title);
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/images/newLanding/PastillasHero.svg",
                            alt: "Meki",
                            width: 400,
                            height: 255
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightsReservedContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTypography, {
                    children: "Meki. Todos los derechos reservados"
                })
            })
        ]
    });
}


/***/ }),

/***/ 23218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ isPointInsideConcaveGeoFence; },
/* harmony export */   "EM": function() { return /* binding */ geoFence; },
/* harmony export */   "tx": function() { return /* binding */ outsidePaintZone; }
/* harmony export */ });
var outsidePaintZone = [
    {
        lat: -35.593687,
        lng: -77.158622
    },
    {
        lat: -35.593687,
        lng: -66.457938
    },
    {
        lat: -31.164653,
        lng: -66.457938
    },
    {
        lat: -31.164653,
        lng: -77.158622
    }, 
];
var geoFence = [
    {
        lng: -70.5340809698431,
        lat: -33.31755335108771
    },
    {
        lng: -70.49388069182629,
        lat: -33.324885575754486
    },
    {
        lng: -70.48191978314313,
        lat: -33.34530658895768
    },
    {
        lng: -70.47352166738044,
        lat: -33.35444778970749
    },
    {
        lng: -70.47617639104433,
        lat: -33.36448256792787
    },
    {
        lng: -70.49202716926878,
        lat: -33.36919066154004
    },
    {
        lng: -70.49000547517346,
        lat: -33.38950561793633
    },
    {
        lng: -70.50502305468201,
        lat: -33.418504610278966
    },
    {
        lng: -70.51589245866941,
        lat: -33.425216616396575
    },
    {
        lng: -70.513052628196,
        lat: -33.46851239892246
    },
    {
        lng: -70.50944889373103,
        lat: -33.475848251181084
    },
    {
        lng: -70.51192414205464,
        lat: -33.47939652266697
    },
    {
        lng: -70.51033455774966,
        lat: -33.49123869197398
    },
    {
        lng: -70.51352559785931,
        lat: -33.49714236379804
    },
    {
        lng: -70.51396214993906,
        lat: -33.503529946025886
    },
    {
        lng: -70.52418053074624,
        lat: -33.52302751889035
    },
    {
        lng: -70.52934274634562,
        lat: -33.53136082066527
    },
    {
        lng: -70.53937325465306,
        lat: -33.537919640599796
    },
    {
        lng: -70.54438073229515,
        lat: -33.54677554004583
    },
    {
        lng: -70.53095397257368,
        lat: -33.552408881207846
    },
    {
        lng: -70.52953116213591,
        lat: -33.56154412058259
    },
    {
        lng: -70.53059249376084,
        lat: -33.580344816724576
    },
    {
        lng: -70.52857905744159,
        lat: -33.58500698946592
    },
    {
        lng: -70.5309190881835,
        lat: -33.59450010023223
    },
    {
        lng: -70.53021301407644,
        lat: -33.59698407977191
    },
    {
        lng: -70.53255554517756,
        lat: -33.601890454387494
    },
    {
        lng: -70.53282353278706,
        lat: -33.6036333778377
    },
    {
        lng: -70.53073287710008,
        lat: -33.60724856911912
    },
    {
        lng: -70.53090781912333,
        lat: -33.61417308975203
    },
    {
        lng: -70.53141646640618,
        lat: -33.61424340369044
    },
    {
        lng: -70.53643151303022,
        lat: -33.617073671773724
    },
    {
        lng: -70.54008242105692,
        lat: -33.615612285196526
    },
    {
        lng: -70.5435415843577,
        lat: -33.61556527494975
    },
    {
        lng: -70.54545900282191,
        lat: -33.615017657463326
    },
    {
        lng: -70.54712801734355,
        lat: -33.61476048402403
    },
    {
        lng: -70.56734538916263,
        lat: -33.620747851133295
    },
    {
        lng: -70.57353676525264,
        lat: -33.623317543432535
    },
    {
        lng: -70.5862969546623,
        lat: -33.63027424925055
    },
    {
        lng: -70.58951176784433,
        lat: -33.63191984651928
    },
    {
        lng: -70.59277149304503,
        lat: -33.63158353862474
    },
    {
        lng: -70.59290533536887,
        lat: -33.63031949503178
    },
    {
        lng: -70.59420403918726,
        lat: -33.62409564044748
    },
    {
        lng: -70.59598384609784,
        lat: -33.61488478790813
    },
    {
        lng: -70.59975892665543,
        lat: -33.61521627734471
    },
    {
        lng: -70.60261472496292,
        lat: -33.60957183627135
    },
    {
        lng: -70.60279605498778,
        lat: -33.60656026153878
    },
    {
        lng: -70.605886859486,
        lat: -33.59788338499931
    },
    {
        lng: -70.62689756323437,
        lat: -33.60034831552053
    },
    {
        lng: -70.62919492315346,
        lat: -33.57703785612881
    },
    {
        lng: -70.64481707400684,
        lat: -33.575705973893996
    },
    {
        lng: -70.66023049742024,
        lat: -33.57375300132067
    },
    {
        lng: -70.66196783173622,
        lat: -33.58040314832585
    },
    {
        lng: -70.66344808691017,
        lat: -33.585359621355096
    },
    {
        lng: -70.67435086300132,
        lat: -33.619687863341156
    },
    {
        lng: -70.67634785285145,
        lat: -33.62069363784915
    },
    {
        lng: -70.67968851107291,
        lat: -33.61982235347107
    },
    {
        lng: -70.68071312288897,
        lat: -33.61933406912124
    },
    {
        lng: -70.6818461068388,
        lat: -33.619116520172895
    },
    {
        lng: -70.68239618262277,
        lat: -33.61663582514881
    },
    {
        lng: -70.69656434935929,
        lat: -33.61129327142051
    },
    {
        lng: -70.69695150978644,
        lat: -33.61532950512341
    },
    {
        lng: -70.6985053035217,
        lat: -33.61898809489572
    },
    {
        lng: -70.69921482679526,
        lat: -33.618662651919486
    },
    {
        lng: -70.7070824321706,
        lat: -33.615651048548024
    },
    {
        lng: -70.71158211568111,
        lat: -33.61400052018032
    },
    {
        lng: -70.71576979209021,
        lat: -33.6135359581455
    },
    {
        lng: -70.71597371443099,
        lat: -33.60433712455902
    },
    {
        lng: -70.71381021110984,
        lat: -33.587239545385366
    },
    {
        lng: -70.71342560264189,
        lat: -33.5706171856882
    },
    {
        lng: -70.74278873069929,
        lat: -33.5467445997527
    },
    {
        lng: -70.75972713124708,
        lat: -33.56264085261284
    },
    {
        lng: -70.76802120784023,
        lat: -33.57170040809892
    },
    {
        lng: -70.78089010300343,
        lat: -33.568894696502284
    },
    {
        lng: -70.79797380758923,
        lat: -33.57717737082461
    },
    {
        lng: -70.81094473246992,
        lat: -33.56612607122262
    },
    {
        lng: -70.79850972799586,
        lat: -33.55580888328373
    },
    {
        lng: -70.80445222339891,
        lat: -33.551777249470156
    },
    {
        lng: -70.80961103754741,
        lat: -33.547312461487785
    },
    {
        lng: -70.80621183858392,
        lat: -33.54367648895268
    },
    {
        lng: -70.80401986373076,
        lat: -33.53802814765642
    },
    {
        lng: -70.79996806674941,
        lat: -33.52840121051706
    },
    {
        lng: -70.79962789899109,
        lat: -33.52286191175647
    },
    {
        lng: -70.79957478539444,
        lat: -33.51918388332969
    },
    {
        lng: -70.79948631846187,
        lat: -33.518926497322575
    },
    {
        lng: -70.79935830867821,
        lat: -33.518661999140804
    },
    {
        lng: -70.79951661024046,
        lat: -33.51841185880507
    },
    {
        lng: -70.79949597980256,
        lat: -33.518038964021294
    },
    {
        lng: -70.79961120709798,
        lat: -33.51688192049263
    },
    {
        lng: -70.79964841372023,
        lat: -33.51567348101139
    },
    {
        lng: -70.79960077884839,
        lat: -33.51430415606793
    },
    {
        lng: -70.79960549801461,
        lat: -33.5127966596908
    },
    {
        lng: -70.79957531448794,
        lat: -33.51101269087485
    },
    {
        lng: -70.79953239878228,
        lat: -33.509591862441994
    },
    {
        lng: -70.80023989097019,
        lat: -33.50914593023975
    },
    {
        lng: -70.80160898076277,
        lat: -33.507682517351384
    },
    {
        lng: -70.79723067561878,
        lat: -33.49918554348022
    },
    {
        lng: -70.78554330625093,
        lat: -33.496188907552984
    },
    {
        lng: -70.78686848233045,
        lat: -33.49098512330935
    },
    {
        lng: -70.76520496187196,
        lat: -33.47982339969227
    },
    {
        lng: -70.78362706064843,
        lat: -33.46303644441759
    },
    {
        lng: -70.78774742381043,
        lat: -33.452549001317365
    },
    {
        lng: -70.78600908819108,
        lat: -33.44646842206619
    },
    {
        lng: -70.78538447062456,
        lat: -33.44358962050774
    },
    {
        lng: -70.78587537964385,
        lat: -33.441599448194864
    },
    {
        lng: -70.78608342269354,
        lat: -33.43890109166597
    },
    {
        lng: -70.78644482144385,
        lat: -33.43324130362234
    },
    {
        lng: -70.7855333233296,
        lat: -33.426636949125204
    },
    {
        lng: -70.78371032710103,
        lat: -33.41909364833023
    },
    {
        lng: -70.78459019016188,
        lat: -33.40684002820463
    },
    {
        lng: -70.74562925521742,
        lat: -33.37169713613439
    },
    {
        lng: -70.76350439982318,
        lat: -33.368100113750344
    },
    {
        lng: -70.76654637515445,
        lat: -33.36397764739507
    },
    {
        lng: -70.76927131221147,
        lat: -33.355958909901204
    },
    {
        lng: -70.77844491193949,
        lat: -33.3387421115004
    },
    {
        lng: -70.78168858000548,
        lat: -33.3248265537677
    },
    {
        lng: -70.77391114699658,
        lat: -33.320266734081
    },
    {
        lng: -70.76715939662193,
        lat: -33.31598952943832
    },
    {
        lng: -70.76818249051941,
        lat: -33.313029232641995
    },
    {
        lng: -70.75289022514977,
        lat: -33.30667900963587
    },
    {
        lng: -70.74540980049787,
        lat: -33.29982240992626
    },
    {
        lng: -70.733386823332,
        lat: -33.294615044609756
    },
    {
        lng: -70.75068156616227,
        lat: -33.25742653887547
    },
    {
        lng: -70.72681835360068,
        lat: -33.24946731746886
    },
    {
        lng: -70.72192895957147,
        lat: -33.24886035901123
    },
    {
        lng: -70.71468698075842,
        lat: -33.243924901759264
    },
    {
        lng: -70.71119372248128,
        lat: -33.24514988886815
    },
    {
        lng: -70.70998338232627,
        lat: -33.24624854456293
    },
    {
        lng: -70.70747698130964,
        lat: -33.244670850919235
    },
    {
        lng: -70.70449238223898,
        lat: -33.24296691239341
    },
    {
        lng: -70.70289448301854,
        lat: -33.24215044858357
    },
    {
        lng: -70.70173363690589,
        lat: -33.241892590761516
    },
    {
        lng: -70.69890189317545,
        lat: -33.241803463350585
    },
    {
        lng: -70.69821990874058,
        lat: -33.24178873249102
    },
    {
        lng: -70.69539491768005,
        lat: -33.23676948044425
    },
    {
        lng: -70.69371927530972,
        lat: -33.23694038090557
    },
    {
        lng: -70.68623857200562,
        lat: -33.23691770445718
    },
    {
        lng: -70.67901387460819,
        lat: -33.23625264878832
    },
    {
        lng: -70.67192931842294,
        lat: -33.22680012799294
    },
    {
        lng: -70.66357180959302,
        lat: -33.2226717050581
    },
    {
        lng: -70.65622204312022,
        lat: -33.219547333139644
    },
    {
        lng: -70.64048812062836,
        lat: -33.22164441472576
    },
    {
        lng: -70.63415809575838,
        lat: -33.230703707897995
    },
    {
        lng: -70.65301032984607,
        lat: -33.238026040471176
    },
    {
        lng: -70.66223180052725,
        lat: -33.24312503731243
    },
    {
        lng: -70.66291089128127,
        lat: -33.24508151123281
    },
    {
        lng: -70.66461913440148,
        lat: -33.246053859070045
    },
    {
        lng: -70.66462379354883,
        lat: -33.24681607703156
    },
    {
        lng: -70.66577100901034,
        lat: -33.247053590823754
    },
    {
        lng: -70.66561804004093,
        lat: -33.24760707707848
    },
    {
        lng: -70.66538189638177,
        lat: -33.24791692087468
    },
    {
        lng: -70.65589888948041,
        lat: -33.26119185687075
    },
    {
        lng: -70.62029492655634,
        lat: -33.24225939394838
    },
    {
        lng: -70.53404829900131,
        lat: -33.31752702152211
    }, 
];
function toRadians(degrees) {
    return degrees * (Math.PI / 180);
}
function calculateDistance(point, lineStart, lineEnd) {
    var A = point.lat - lineStart.lat;
    var B = point.lng - lineStart.lng;
    var C = lineEnd.lat - lineStart.lat;
    var D = lineEnd.lng - lineStart.lng;
    var dot = A * C + B * D;
    var len_sq = C * C + D * D;
    var param = -1;
    if (len_sq != 0) //in case of 0 length line
    param = dot / len_sq;
    var xx, yy;
    if (param < 0) {
        xx = lineStart.lat;
        yy = lineStart.lng;
    } else if (param > 1) {
        xx = lineEnd.lat;
        yy = lineEnd.lng;
    } else {
        xx = lineStart.lat + param * C;
        yy = lineStart.lng + param * D;
    }
    var dx = point.lat - xx;
    var dy = point.lng - yy;
    return Math.sqrt(dx * dx + dy * dy);
}
function isPointInsideConcaveGeoFence(point) {
    var accuracy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.00000000000001;
    var lat = toRadians(point.lat);
    var lng = toRadians(point.lng);
    var inside = false;
    for(var i = 0, j = geoFence.length - 1; i < geoFence.length; j = i++){
        var xi = toRadians(geoFence[i].lat);
        var yi = toRadians(geoFence[i].lng);
        var xj = toRadians(geoFence[j].lat);
        var yj = toRadians(geoFence[j].lng);
        var intersect = yi > lng != yj > lng && lat < (xj - xi) * (lng - yi) / (yj - yi) + xi;
        if (intersect || calculateDistance(point, {
            lat: xi,
            lng: yi
        }, {
            lat: xj,
            lng: yj
        }) <= accuracy) inside = !inside;
    }
    return inside;
}


/***/ })

}]);